// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "practitioner_location".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "practitioner_location" table (1:1 with a DB row, on the wire). */
export const practitionerLocationAtomSchema = z.object({
    id: z.string(),
    practitionerId: z.string(),
    locationId: z.string(),
    workingHours: z.unknown().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=practitionerLocation.js.map